import axios from './axios'

const prefix = '/v2/notice'
const prefixAttachment= '/v2/attachment'

export function getNoticeList(COMPANY_ID: string, SHOP_ID: string, lastNoticeIndex: string, noticeAmount: string, sortType: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, SHOP_ID, lastNoticeIndex, noticeAmount, sortType })
      const response = await axios.get(`${prefix}/list?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefix} getNoticeList error: `, e)
      reject(e)
    }
  })
}

export function getFixedNoticeList(COMPANY_ID: string, SHOP_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, SHOP_ID,  })
      const response = await axios.get(`${prefix}/fixedList?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefix} getFixedNoticeList error: `, e)
      reject(e)
    }
  })
}

export function getNewNoticeList(COMPANY_ID: string, SHOP_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, SHOP_ID })
      const response = await axios.get(`${prefix}/newList?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefix} getNewNoticeList error: `, e)
      reject(e)
    }
  })
}

export function getNotice(COMPANY_ID: string, SHOP_ID: string, POST_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, SHOP_ID, POST_ID })
      const response = await axios.get(`${prefix}/detail?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefix} getNotice error: `, e)
      reject(e)
    }
  })
}

export function createNotice(COMPANY_ID: string, item: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(`${prefix}/create`, { COMPANY_ID, item });
      console.log(`${prefix}create response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix} createNotice error: `, e)
      reject(e)
    }
  })
}

export function updateNotice(COMPANY_ID: string, item: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(`${prefix}/update`, { COMPANY_ID, item });
      console.log(`${prefix}update response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix} updateNotice error: `, e)
      reject(e)
    }
  })
}

export function deleteNotice(COMPANY_ID: string, item: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(`${prefix}/delete`, { COMPANY_ID, item });
      console.log(`${prefix}delete response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix} deleteNotice error: `, e)
      reject(e)
    }
  })
}

export function getNoticeGroup(COMPANY_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID })
      const response = await axios.get(`${prefix}/group/list?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefix} getNoticeGroupList error: `, e)
      reject(e)
    }
  })
}

export function getShopNoticeGroup(COMPANY_ID: string, SHOP_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, SHOP_ID })
      const response = await axios.get(`${prefix}/group/list?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefix} getNoticeGroupList error: `, e)
      reject(e)
    }
  })
}

export function createGroup(COMPANY_ID: string, item: any) {
 return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(`${prefix}/group/create`, { COMPANY_ID, item });
      console.log(`${prefix}create response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix}createGroup error: `, e);
      reject(e);
    }
  });
}

export function updateGroup(COMPANY_ID: string, item: any) {
  return new Promise(async (resolve, reject) => {
     try {
       const response = await axios.post(`${prefix}/group/update`, { COMPANY_ID, item });
       console.log(`${prefix}update response: `, response);
       resolve(response);
     } catch (e) {
       console.log(`${prefix}updateGroup error: `, e);
       reject(e);
     }
   });
 }

 export function deleteGroup(COMPANY_ID: string, item: any) {
  return new Promise(async (resolve, reject) => {
     try {
       const response = await axios.post(`${prefix}/group/delete`, { COMPANY_ID, item });
       console.log(`${prefix}delete response: `, response);
       resolve(response);
     } catch (e) {
       console.log(`${prefix}deleteGroup error: `, e);
       reject(e);
     }
   });
 }

 export function getNoticeGroupDetail(COMPANY_ID: string, GROUP_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, GROUP_ID })
      const response = await axios.get(`${prefix}/group/detail?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefix} getNoticeGroupList error: `, e)
      reject(e)
    }
  })
}

export function getAttachment(COMPANY_ID: string, SHOP_ID: string, POST_ID: string, FILE_ID: string, INTERNAL_URL: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, SHOP_ID, POST_ID, FILE_ID, INTERNAL_URL })
      const response = await axios.get(`${prefixAttachment}/download?${searchParams.toString()}`)
      resolve(response)
    } catch (e) {
      console.log(`${prefixAttachment} getNoticeGroupList error: `, e)
      reject(e)
    }
  })
}